import React from 'react'
import Weekly from './Weekly'
import Monthly from './Monthly'

const charts = {
  weekly: Weekly,
  monthly: Monthly,
}

export default ({
  formikProps: {
    values: {
      resolution,
    },
  },
  formikProps,
  ...rest
}) => {
  const Component = charts[resolution]

  return (
    <Component
      formikProps={formikProps}
      {...rest}
    />
  )
}
